import script from "./ProjectGlobe.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectGlobe.vue?vue&type=script&setup=true&lang=js"

import "./ProjectGlobe.vue?vue&type=style&index=0&id=028a91d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028a91d6"]])

export default __exports__